var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullGrad fullHeight"},[_c('router-view'),_c('span',{staticClass:"version",class:{ mobile: _vm.isApp }},[_vm._v("v."+_vm._s(_vm.version))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }